var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-1", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _vm.$store.state.Auth.userProperties.system_settings
                .delegation_order_type !== 1
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("delegation-order-select", {
                        attrs: {
                          "delegation-id": _vm.delegation.id,
                          "delegation-order-id":
                            _vm.delegation.delegation_order_id,
                          "delegation-order-number":
                            _vm.delegation.delegation_order_number,
                          "error-messages":
                            _vm.delegationErrors.delegation_order_id
                        },
                        on: {
                          "update:delegationOrderId": function($event) {
                            return _vm.$set(
                              _vm.delegation,
                              "delegation_order_id",
                              $event
                            )
                          },
                          "update:delegation-order-id": function($event) {
                            return _vm.$set(
                              _vm.delegation,
                              "delegation_order_id",
                              $event
                            )
                          },
                          "update:delegationOrderNumber": function($event) {
                            return _vm.$set(
                              _vm.delegation,
                              "delegation_order_number",
                              $event
                            )
                          },
                          "update:delegation-order-number": function($event) {
                            return _vm.$set(
                              _vm.delegation,
                              "delegation_order_number",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { md: "6", sm: "6", cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "error-messages": _vm.delegationErrors.user_id,
                      items: _vm.users,
                      label: _vm.$t("delegation.form.fields.delegated.name"),
                      "item-text": "fullName",
                      "item-value": "id",
                      readonly: _vm.$store.state.Delegation.readonly === true
                    },
                    model: {
                      value: _vm.contextUser,
                      callback: function($$v) {
                        _vm.contextUser = $$v
                      },
                      expression: "contextUser"
                    }
                  })
                ],
                1
              ),
              _vm.companies.length > 1
                ? _c(
                    "v-col",
                    { attrs: { md: "6", sm: "6", cols: "12" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          "error-messages": _vm.delegationErrors.company_id,
                          items: _vm.companies,
                          label: _vm.$t("delegation.form.fields.company.name"),
                          "item-text": "name",
                          "item-value": "id",
                          readonly:
                            _vm.$store.state.Delegation.readonly === true
                        },
                        model: {
                          value: _vm.delegation.company_id,
                          callback: function($$v) {
                            _vm.$set(_vm.delegation, "company_id", $$v)
                          },
                          expression: "delegation.company_id"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { md: "6", sm: "6", cols: "12" } },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        disabled:
                          _vm.$store.state.Auth.userProperties.system_settings
                            .delegation_number_setting_type !== 2,
                        top: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.$store.state.Auth.userProperties
                                          .system_settings
                                          .delegation_number_setting_type === 3,
                                      "error-messages":
                                        _vm.delegationErrors.custom_number,
                                      label: _vm.$t(
                                        "delegation.form.fields.delegationNumber.name"
                                      ),
                                      placeholder:
                                        _vm.$store.state.Auth.userProperties
                                          .system_settings
                                          .delegation_number_setting_type !== 1
                                          ? _vm.$t(
                                              "delegation.form.fields.delegationNumber.willBeAuto"
                                            )
                                          : null,
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    model: {
                                      value: _vm.delegation.custom_number,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.delegation,
                                          "custom_number",
                                          $$v
                                        )
                                      },
                                      expression: "delegation.custom_number"
                                    }
                                  },
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "delegation.form.fields.delegationNumber.leftEmptyToAutomatic"
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.$store.getters["userProperties"].system_settings
                .is_delegation_task_enabled === 2
                ? _c(
                    "v-col",
                    { attrs: { md: "6", sm: "6", cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          "error-messages": _vm.delegationErrors.task_id,
                          items: _vm.delegation_tasks,
                          label: _vm.$t("delegation.form.fields.task.name"),
                          readonly:
                            _vm.$store.state.Delegation.readonly === true
                        },
                        model: {
                          value: _vm.delegation.task_id,
                          callback: function($$v) {
                            _vm.$set(_vm.delegation, "task_id", $$v)
                          },
                          expression: "delegation.task_id"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { md: "6", sm: "6", cols: "12" } },
                [
                  _c("location-ajax-select-multiple", {
                    attrs: {
                      "default-items": _vm.delegation.destinationObjects,
                      label: _vm.$t("delegation.form.fields.destination.name"),
                      placeholder: _vm.delegation.destinationText,
                      "select-model": _vm.delegation.destination,
                      "select-validation": _vm.delegationErrors.destination,
                      multiple: true,
                      readonly: _vm.$store.state.Delegation.readonly === true
                    },
                    on: {
                      "update:selectModel": function($event) {
                        return _vm.$set(_vm.delegation, "destination", $event)
                      },
                      "update:select-model": function($event) {
                        return _vm.$set(_vm.delegation, "destination", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.companies.length === 1 &&
              _vm.$store.getters["userProperties"].system_settings
                .is_delegation_task_enabled === 2
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "error-messages": _vm.delegationErrors.task,
                          label: _vm.$t(
                            "delegation.form.fields.taskDescription.name"
                          ),
                          readonly:
                            _vm.$store.state.Delegation.readonly === true
                        },
                        model: {
                          value: _vm.delegation.task,
                          callback: function($$v) {
                            _vm.$set(_vm.delegation, "task", $$v)
                          },
                          expression: "delegation.task"
                        }
                      })
                    ],
                    1
                  )
                : _vm.$store.getters["userProperties"].system_settings
                    .is_delegation_task_enabled === 2
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "error-messages": _vm.delegationErrors.task,
                          label: _vm.$t(
                            "delegation.form.fields.taskDescription.name"
                          ),
                          readonly:
                            _vm.$store.state.Delegation.readonly === true
                        },
                        model: {
                          value: _vm.delegation.task,
                          callback: function($$v) {
                            _vm.$set(_vm.delegation, "task", $$v)
                          },
                          expression: "delegation.task"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isReInvoicingForExternalContractorModuleEnabled
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.externalCustomers,
                          "error-messages":
                            _vm.delegationErrors.external_customer_id,
                          clearable: "",
                          label: _vm.$t(
                            "delegation.form.fields.externalCustomer.name"
                          ),
                          readonly:
                            _vm.$store.state.Delegation.readonly === true
                        },
                        on: { change: _vm.changedExternalCustomer },
                        model: {
                          value: _vm.delegation.external_customer_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.delegation,
                              "external_customer_id",
                              $$v
                            )
                          },
                          expression: "delegation.external_customer_id"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isReInvoicingForExternalContractorModuleEnabled
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.projectsForExternalCustomer,
                          clearable: "",
                          label: _vm.$t("delegation.form.fields.project.name"),
                          "error-messages": _vm.delegationErrors.project_id,
                          readonly:
                            _vm.$store.state.Delegation.readonly === true,
                          "persistent-hint": "",
                          hint:
                            typeof _vm.projects.find(function(v) {
                              return v.value === _vm.delegation.project_id
                            }) === "undefined"
                              ? ""
                              : _vm.$t("global.orderNumber") +
                                ": " +
                                _vm.projects.find(function(v) {
                                  return v.value === _vm.delegation.project_id
                                }).order_number
                        },
                        model: {
                          value: _vm.delegation.project_id,
                          callback: function($$v) {
                            _vm.$set(_vm.delegation, "project_id", $$v)
                          },
                          expression: "delegation.project_id"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { md: "6", sm: "6", cols: "12" } },
                [
                  _c("date-time-picker-model-computed", {
                    attrs: {
                      "time-required": true,
                      "date-label": _vm.$t(
                        "delegation.form.fields.startDate.dateName"
                      ),
                      "date-time-validation": _vm.delegationErrors.start_date,
                      dateTimeModel: _vm.delegation.start_date,
                      "time-label": _vm.$t(
                        "delegation.form.fields.startDate.timeName"
                      ),
                      readonly: _vm.$store.state.Delegation.readonly === true
                    },
                    on: {
                      "update:dateTimeModel": function($event) {
                        return _vm.$set(_vm.delegation, "start_date", $event)
                      },
                      "update:date-time-model": function($event) {
                        return _vm.$set(_vm.delegation, "start_date", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "6", sm: "6", cols: "12" } },
                [
                  _c("date-time-picker-model-computed", {
                    attrs: {
                      "time-required": true,
                      "date-label": _vm.$t(
                        "delegation.form.fields.endDate.dateName"
                      ),
                      "date-time-validation": _vm.delegationErrors.end_date,
                      dateTimeModel: _vm.delegation.end_date,
                      "time-label": _vm.$t(
                        "delegation.form.fields.endDate.timeName"
                      ),
                      readonly: _vm.$store.state.Delegation.readonly === true
                    },
                    on: {
                      "update:dateTimeModel": function($event) {
                        return _vm.$set(_vm.delegation, "end_date", $event)
                      },
                      "update:date-time-model": function($event) {
                        return _vm.$set(_vm.delegation, "end_date", $event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { md: "12", sm: "12", cols: "12" } },
                [
                  _c("collapse-simple-advance-panel", {
                    attrs: {
                      clearable: _vm.$store.state.Delegation.readonly !== true,
                      addable: _vm.$store.state.Delegation.readonly !== true,
                      "model-advances": _vm.delegation.advances,
                      "validation-model": _vm.delegationErrors.advances,
                      "max-date": _vm.delegation.end_date,
                      readonly: _vm.$store.state.Delegation.readonly === true
                    },
                    on: {
                      "update:modelAdvances": function($event) {
                        return _vm.$set(_vm.delegation, "advances", $event)
                      },
                      "update:model-advances": function($event) {
                        return _vm.$set(_vm.delegation, "advances", $event)
                      },
                      addAdvanceItem: _vm.addDelegationAdvance,
                      removeAdvanceItem: _vm.removeAdvance
                    }
                  })
                ],
                1
              ),
              _vm.$store.state.Auth.userProperties.system_settings
                .cost_centre_on_delegations !== 3
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          "error-messages": _vm.delegationErrors.cost_centre_id,
                          items: _vm.availableCostCentres,
                          label: _vm.$t(
                            "delegation.form.fields.costCentre.name"
                          ),
                          clearable:
                            _vm.$store.state.Delegation.readonly !== true,
                          "item-text": "name",
                          "item-value": "id",
                          readonly:
                            _vm.$store.state.Delegation.readonly === true
                        },
                        model: {
                          value: _vm.delegation.cost_centre_id,
                          callback: function($$v) {
                            _vm.$set(_vm.delegation, "cost_centre_id", $$v)
                          },
                          expression: "delegation.cost_centre_id"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("date-picker", {
                    attrs: {
                      label: _vm.$t("delegation.form.fields.settledAt.name"),
                      model: _vm.delegation.settlement_date,
                      readonly: _vm.$store.state.Delegation.readonly === true
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(
                          _vm.delegation,
                          "settlement_date",
                          $event
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm.$store.getters["userProperties"].system_settings
                .is_module_optima_enabled
                ? _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("optima-category-select", {
                        attrs: { value: _vm.delegation.optima_category_code },
                        on: {
                          "update:value": function($event) {
                            return _vm.$set(
                              _vm.delegation,
                              "optima_category_code",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }